"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusLabel = void 0;
var react_i18next_1 = require("react-i18next");
var constants_1 = require("../../constants");
var useStatusLabel = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var CORRECT = constants_1.OPTION_LABEL.CORRECT, INCORRECT = constants_1.OPTION_LABEL.INCORRECT, CORRECT_NOT_SELECTED = constants_1.OPTION_LABEL.CORRECT_NOT_SELECTED, NOT_SELECTED = constants_1.OPTION_LABEL.NOT_SELECTED;
    return function (status) {
        switch (status) {
            case CORRECT:
                return t('common.statusLabel.correct');
            case INCORRECT:
                return t('common.statusLabel.incorrect');
            case CORRECT_NOT_SELECTED:
                return t('common.statusLabel.correctNotSelected');
            case NOT_SELECTED:
            default:
                return '';
        }
    };
};
exports.useStatusLabel = useStatusLabel;
